import { Id } from "@dhx/ts-common/types";

class CollectionStore {
	private _store: { [id: string]: any } = {};

	setItem(id: Id, target: any): void {
		this._store[id] = target;
	}
	getItem(id: Id) {
		if (!this._store[id]) {
			return null;
		}
		return this._store[id];
	}
}

const dhx = ((window as any).dhxHelpers = (window as any).dhxHelpers || {});
dhx.collectionStore = dhx.collectionStore || new CollectionStore();
export const collectionStore = dhx.collectionStore;
